module.exports = __webpack_public_path__ + "img/hp-mcafee.65ebecb5.svg";